export function formatMoney(val) {
  if (!val) return "0";

  return Number(val).toLocaleString("vi-VN");
}